import {useNavigate} from 'react-router';
import {CreatePublicServiceConsentRequest} from '@di-shared/api/di/__generated';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import LottieSelector from '@di-shared/features/common/LottieSelector';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {ROUTE_PATHS} from '@di-shared/routes';

interface LicenseRenewalAboutProps {
  vin: string;
}

function LicenseRenewalAbout({vin}: LicenseRenewalAboutProps) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();

  function goToAgreePage() {
    navigate(
      ROUTE_PATHS.PUBLIC_SERVICE_CONSENTS_$CATEGORY.getFullPath({
        vin,
        category: CreatePublicServiceConsentRequest.category.LICENSE_RENEWAL,
        nextUrl: ROUTE_PATHS.HOME_FINANCE_TAB.getFullPath(vin),
      }),
      {replace: true}
    );
  }

  return (
    <div className="wrap">
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T10212')}</h1>
      </Header>
      <main className="content">
        <section className="section section_vehicle_intro penalty_point">
          <section className="section">
            <div className="intro_heading">
              <h2
                className="intro_heading_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T10214')}
              </h2>
              <p
                className="intro_desc"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T10215')}
              </p>
            </div>
            <div className="intro_motion">
              <div className="intro_imgbox">
                <LottieSelector
                  kiaLightSrc={() => import('@di-shared/assets/img/json/driver_license_renewal_intro.json')}
                  kiaDarkSrc={() => import('@di-shared/assets/img/json/driver_license_renewal_intro.json')}
                  hyundaiLightSrc={() => import('@di-shared/assets/img/json/driver_license_renewal_intro.json')}
                  hyundaiDarkSrc={() => import('@di-shared/assets/img/json/driver_license_renewal_intro.json')}
                  genesisLightSrc={() => import('@di-shared/assets/img/json/driver_license_renewal_intro.json')}
                  genesisDarkSrc={() => import('@di-shared/assets/img/json/driver_license_renewal_intro.json')}
                />
              </div>
            </div>
          </section>
        </section>
        <section className="section section_notice">
          <div className="section_container">
            <strong className="notice_title">{t('T10216')}</strong>
            <ul className="notice_list">
              <li className="notice_item">{t('T10217')}</li>
              <li className="notice_item">{t('T10281')}</li>
            </ul>
          </div>
        </section>
      </main>
      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => goToAgreePage()}
        >
          {t('T10218')}
        </button>
      </div>
    </div>
  );
}

export default LicenseRenewalAbout;
